/**
 * Подпись роли пользователя для профиля в приложении. Служебные коды ролей не показываются:
 * для клиента строка «Роль» не нужна (null), неизвестная роль тоже скрывается.
 */
export function profileRoleLabel(role: string | null | undefined): string | null {
  const r = (role || '').trim().toLowerCase();
  if (!r || r === 'client') return null;
  if (r === 'trainer' || r.includes('trainer')) return 'Тренер';
  if (r === 'superadmin' || r.startsWith('platform')) return 'Сотрудник платформы';
  if (r.includes('admin') || r.includes('manager') || r.includes('staff')) return 'Сотрудник студии';
  return null;
}
